var render, staticRenderFns
import script from "./loginVerify.vue?vue&type=script&lang=ts"
export * from "./loginVerify.vue?vue&type=script&lang=ts"
import style0 from "./loginVerify.scss?vue&type=style&index=0&id=4522c488&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522c488",
  null
  
)

export default component.exports